import TreatmentGroupEnrollmentButton from './TreatmentGroupEnrollmentButton';

export default TreatmentGroupEnrollmentButton;
